import React, { FC }                      from 'react';
import { Label, Popup, PopupProps }       from 'semantic-ui-react';
import { Cell, Grid }                     from 'styled-css-grid';
import { CorvalLogo, CorvalLogoVersions } from './CorvalLogo';
import { StyledContainer }                from '../../containers';
import { CorvalUIColor, SemanticUIColor } from '../../../types';

interface Props {
	popupProps?: PopupProps,
	withLogo?: boolean,
}

const defaultProps: Props = {
	popupProps: {},
	withLogo:   false,
}

const CorvalRecommendedTag: FC<Props> = ( props ) => {
	
	return (
		
		<Popup size={ 'tiny' }
		       position={ 'top right' }
		       content={ `Based on your assumptions, this objective is recommended by Corval; your team should consider this objective when planning your goals for commercialization.` }
		       { ...props.popupProps }
		       trigger={ (
			
			       <StyledContainer bgColor={ SemanticUIColor.BLUE }
			                        textColor={ CorvalUIColor.WHITE }
			                        className={ 'display--inline-block cursor--pointer text--xs opacity--100 opacity-hover--90' }
			                        style={ { padding: '2px 10px', borderRadius: 15 } }>
				
				       <Grid columns={ `auto auto` } rows={ 'auto' } columnGap={ !props.withLogo ? '0px' : null }>
					
					       <Cell middle center>
						       { props.withLogo && <CorvalLogo type={ CorvalLogoVersions.COLOR_HEX_LOGO } width={ 16 }/> }
					       </Cell>
					
					       <Cell middle>Recommended</Cell>
				
				       </Grid>
			       </StyledContainer>
		
		       ) }/>
	);
};

CorvalRecommendedTag.defaultProps = defaultProps;

export { CorvalRecommendedTag }
